module.exports = __webpack_public_path__ + "img/networkThreeImg.d67471ce.png";